import React from 'react';
import ESSSection from '@/components/ess/ESSSection';

const SSHRPage = () => {
    return (
        <div className="space-y-6" data-testid="sshr-page">
            <ESSSection />
        </div>
    );
};

export default SSHRPage;
